/**
 * Утилита для определения flow параметра из URL или из creationMethod
 * @param searchParams - URLSearchParams из location.search
 * @param creationMethod - метод создания из store (fallback)
 * @returns flow значение для аналитики
 */
export const getFlowFromUrl = (
  searchParams?: URLSearchParams | string,
  creationMethod?: string,
): 'prompt' | 'pdf' | 'docx' | 'pptx' | 'blank' | 'templates' | 'unknown' => {
  // Если searchParams строка, создаем URLSearchParams
  const params =
    typeof searchParams === 'string' ? new URLSearchParams(searchParams) : searchParams;

  // Пытаемся получить параметр f из URL
  const flowFromUrl = params?.get('f');

  // Если есть параметр в URL, используем его
  if (flowFromUrl) {
    switch (flowFromUrl) {
      case 'prompt':
      case 'pdf':
      case 'docx':
      case 'pptx':
      case 'blank':
      case 'templates':
        return flowFromUrl;
      default:
        console.warn(`[Analytics] Unknown flow parameter in URL: ${flowFromUrl}`);
    }
  }

  // Если нет параметра в URL, используем creationMethod из store
  if (creationMethod) {
    switch (creationMethod) {
      case 'prompt':
      case 'pdf':
      case 'docx':
      case 'pptx':
      case 'blank':
      case 'templates':
        return creationMethod;
      default:
        console.warn(`[Analytics] Unknown creationMethod: ${creationMethod}`);
    }
  }

  // Fallback на unknown
  return 'unknown';
};
